import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M40 70q0-40 60-40t60 40q0 30-15 50t-30 38q-15 16-30 0-15-18-30-38T40 70" }, null, -1),
    _createElementVNode("ellipse", {
      cx: "74",
      cy: "98",
      fill: "var(--mc-avatar)",
      rx: "14",
      ry: "20",
      transform: "rotate(-18 74 98)"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "126",
      cy: "98",
      fill: "var(--mc-avatar)",
      rx: "14",
      ry: "20",
      transform: "rotate(18 126 98)"
    }, null, -1)
  ]))]))
}
export default { render: render }